import React from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  return <motion.nav initial={{
    y: -20,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.5
  }} className="fixed top-0 inset-x-0 z-50 bg-ascension-black/80 backdrop-blur-md border-b border-white/5" data-id="element-159">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-160">
        <div className="flex items-center gap-2" data-id="element-161">
          <div className="w-6 h-6 rounded-md bg-gradient-to-br from-ascension-green to-ascension-dark flex items-center justify-center" data-id="element-162">
            <div className="w-2 h-2 bg-white rounded-full" data-id="element-163" />
          </div>
          <span className="text-white font-semibold tracking-wide text-lg" data-id="element-164">
            Ascension
          </span>
        </div>

        <button className="bg-ascension-green hover:bg-[#3bb34c] text-black px-5 py-2 rounded-full font-medium text-sm transition-colors duration-200" data-id="element-165">
          Join Early Access
        </button>
      </div>
    </motion.nav>;
}